import api from "./api";

/** List captures (params: page, worker, date_from, date_to, etc.) */
export async function fetchCaptures(params = {}) {
  const res = await api.get("/core/captures/", { params });
  return res.data;
}

/** Create capture
 * payload: {
 *   worker: workerId,
 *   variety: varietyId,
 *   harvest_type: harvestTypeId,
 *   length: lengthId,
 *   bunch_size: bunchSizeId,
 *   session: sessionId,
 *   bunch_count: number
 * }
 */
export async function createCapture(payload) {
  try {
    const requiredFields = [
      "worker",
      "variety",
      "harvest_type",
      "length",
      "bunch_size",
      "session",
      "bunch_count",
    ];

    const missing = requiredFields.filter((f) => !(f in payload));
    if (missing.length > 0) {
      throw new Error(`Missing required fields: ${missing.join(", ")}`);
    }

    const res = await api.post("/core/captures/", payload);
    return res.data;
  } catch (err) {
    console.error("Error creating capture:", err);
    throw err;
  }
}

/** Update capture (admin or QC while session open)
 * payload: {
 *   bunch_count,
 *   variety?,
 *   harvest_type?,
 *   length?,
 *   bunch_size?,
 *   session?
 * }
 */
export async function updateCapture(id, payload) {
  try {
    const res = await api.patch(`/core/captures/${id}/`, payload);
    return res.data;
  } catch (err) {
    console.error("Error updating capture:", err);
    throw err;
  }
}

/** Delete capture */
export async function deleteCapture(id) {
  const res = await api.delete(`/core/captures/${id}/`);
  return res.data;
}

/** Get single capture */
export async function getCapture(id) {
  const res = await api.get(`/core/captures/${id}/`);
  return res.data;
}

/** Fetch available bunch sizes */
export async function fetchBunchSizes() {
  const res = await api.get("/core/bunch-sizes/");
  return res.data;
}